import { render, staticRenderFns } from "./orderConfrim.vue?vue&type=template&id=4fad0a45"
import script from "./orderConfrim.vue?vue&type=script&lang=js"
export * from "./orderConfrim.vue?vue&type=script&lang=js"
import style0 from "./orderConfrim.vue?vue&type=style&index=0&id=4fad0a45&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports